import { createSlice } from "@reduxjs/toolkit";
import { exhibitionsAPI } from "../api/exhibitions";

const initialState = {
  myExhibitions: {
    items: [],
    total: 0
  },
  archiveExhibitions: {
    items: [],
    total: 0
  },
  homePageExhibitions: [],
  exhibition: {},
  exhibitionCompanies: [],
  editExhibitionId: null,
  editStandId: null,
  isEditMode: false,
  existExhibitions: [],
  existExhibitionsArchive: [],
  exhibitionPanel: false,
  exhibitionFilterParams: null,
  editOnlyStand: false,
  filterParams: {
    limit: 10,
    page: 0
  },
  exhibitionFilters: [],
  exhibitionInitialValues: {},
  changeEdit: {
    exhibitionId: null,
    standId: null
  },
  savedExhibition: null,
  loading: false,
  checkBoxSelected: { isPrivate: null, isVisible: null }
};
const exhibitionSlice = createSlice({
  name: "exhibitions",
  initialState,
  reducers: {
    setIsExistExhibitions(state, action) {
      state.existExhibitions = action.payload;
    },
    setArchiveExhibitions(state, action) {
      state.archiveExhibitions = action.payload;
    },
    setExistExhibitionsArchive(state, action) {
      state.existExhibitionsArchive = action.payload;
    },
    setMyExhibitions(state, action) {
      state.myExhibitions = action.payload;
    },
    setEditExhibitionId(state, action) {
      state.editExhibitionId = action.payload;
    },
    setEditStandId(state, action) {
      state.editStandId = action.payload;
    },
    setIsEditMode(state, action) {
      state.isEditMode = action.payload;
    },
    setExhibition(state, action) {
      state.exhibition = action.payload;
    },
    setExhibitionCompanies(state, action) {
      state.exhibitionCompanies = action.payload;
    },
    setHomePageExhibitions(state, action) {
      state.homePageExhibitions = action.payload;
    },
    setExhibitionPanel(state, action) {
      state.exhibitionPanel = action.payload;
    },
    setExhibitionFilterParams(state, action) {
      state.exhibitionFilters = action.payload.filters;
      state.filterParams = action.payload.res;
    },
    setEditOnlyStand(state, action) {
      state.editOnlyStand = action.payload;
    },
    setExhibitionInitialValues(state, action) {
      state.exhibitionInitialValues = action.payload;
    },
    setChangeEdit(state, action) {
      state.changeEdit = action.payload;
    },
    setCheckBoxSelected(state, action) {
      state.checkBoxSelected = action.payload;
    },
    setSavedExhibition(state, action) {
      state.savedExhibition = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    }
  }
});

export const {
  setMyExhibitions,
  setEditStandId,
  setCheckBoxSelected,
  setEditExhibitionId,
  setIsEditMode,
  setSavedExhibition,
  setExhibitionPanel,
  setExhibition,
  setIsExistExhibitions,
  setExhibitionFilterParams,
  setExistExhibitionsArchive,
  setExhibitionCompanies,
  setEditOnlyStand,
  setExhibitionInitialValues,
  setChangeEdit,
  setLoading,
  setHomePageExhibitions,
  setArchiveExhibitions
} = exhibitionSlice.actions;

export const fetchMyExhibitions =
  (qParams = {}) =>
    async (dispatch) => {
      dispatch(setLoading(true));
      try {
        const myExhibitions = (await exhibitionsAPI.getExhibitions(qParams)).data;
        if (qParams.isArchive) {
          dispatch(setArchiveExhibitions(myExhibitions));
        } else {
          dispatch(setMyExhibitions(myExhibitions));
        }
      } catch (e) {
        console.log(e);
      }
      dispatch(setLoading(false));
    };

export const fetchHomePageExhibitions = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const homePageExhibitions = (await exhibitionsAPI.getHomePageExhibitions()).data.items;
    dispatch(setHomePageExhibitions(homePageExhibitions));
  } catch (e) {
    console.log(e);
  }
  dispatch(setLoading(false));
};

export const fetchExhibitionById = (exhibitionId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const exhibition = (await exhibitionsAPI.getExhibitionById(exhibitionId)).data;
    dispatch(setExhibition(exhibition));
  } catch (e) {
    console.log(e);
  }
  dispatch(setLoading(false));
};
export const fetchExhibitionCompanies =
  (exhibitionId, qParams = {}) =>
    async (dispatch) => {
      dispatch(setLoading(true));
      try {
        const exhibitionCompanies = (await exhibitionsAPI.getExhibitionCompanies(exhibitionId, qParams)).data;
        dispatch(setExhibitionCompanies(exhibitionCompanies));
      } catch (e) {
        console.log(e);
      }
      dispatch(setLoading(false));
    };


export default exhibitionSlice.reducer;
